import { AbstractControl, ValidationErrors } from '@angular/forms'

export class GenericValidatorService {
	constructor() {}

	static isValidCpf(control: AbstractControl): ValidationErrors | null {
		const { value } = control
		if (value) {
			if (value === undefined) return { cpfInvalid: true }
			const cpf = value.replace(/[^\d]+/g, '')
			let Soma
			let Resto
			Soma = 0
			if (
				cpf.length !== 11 ||
				cpf === '00000000000' ||
				cpf === '11111111111' ||
				cpf === '22222222222' ||
				cpf === '33333333333' ||
				cpf === '44444444444' ||
				cpf === '55555555555' ||
				cpf === '66666666666' ||
				cpf === '77777777777' ||
				cpf === '88888888888' ||
				cpf === '99999999999'
			)
				return { cpfInvalid: true }

			for (let i = 1; i <= 9; i++)
				Soma += parseInt(cpf.substring(i - 1, i)) * (11 - i)
			Resto = (Soma * 10) % 11

			if (Resto === 10 || Resto === 11) Resto = 0

			if (Resto !== parseInt(cpf.substring(9, 10)))
				return { cpfInvalid: true }

			Soma = 0

			for (let i = 1; i <= 10; i++)
				Soma += parseInt(cpf.substring(i - 1, i)) * (12 - i)
			Resto = (Soma * 10) % 11

			if (Resto === 10 || Resto === 11) Resto = 0

			if (Resto !== parseInt(cpf.substring(10, 11)))
				return { cpfInvalid: true }
		}
		return null
	}

    static isValidCPForCNPJ(control: AbstractControl): ValidationErrors | null {
		const { value }  = control

		if (value) {
            if (value === undefined) return { cpfInvalid: true }
            const cleanValue = value.replace(/[.\-\/]/g, '').toUpperCase()

            const isCpf = /^\d{11}$/.test(cleanValue)

            if (isCpf) {
                const cpf = value.replace(/[^\d]+/g, '')
                let Soma
                let Resto
                Soma = 0
                if (
                    cpf.length !== 11 ||
                    cpf === '00000000000' ||
                    cpf === '11111111111' ||
                    cpf === '22222222222' ||
                    cpf === '33333333333' ||
                    cpf === '44444444444' ||
                    cpf === '55555555555' ||
                    cpf === '66666666666' ||
                    cpf === '77777777777' ||
                    cpf === '88888888888' ||
                    cpf === '99999999999'
                )
                    return { cpfInvalid: true }

                for (let i = 1; i <= 9; i++)
                    Soma += parseInt(cpf.substring(i - 1, i)) * (11 - i)
                Resto = (Soma * 10) % 11

                if (Resto === 10 || Resto === 11) Resto = 0

                if (Resto !== parseInt(cpf.substring(9, 10)))
                    return { cpfInvalid: true }

                Soma = 0

                for (let i = 1; i <= 10; i++)
                    Soma += parseInt(cpf.substring(i - 1, i)) * (12 - i)
                Resto = (Soma * 10) % 11

                if (Resto === 10 || Resto === 11) Resto = 0

                if (Resto !== parseInt(cpf.substring(10, 11)))
                    return { cpfInvalid: true }

                return null;
            }
            else {
                const cnpj = value.replace(/[.\-\/]/g, '').toUpperCase();
                if (cnpj === '') return { cnpjInvalid: true }
                if (cnpj.length !== 14) return { cnpjInvalid: true }

                 // os 2 dígitos verificadores (posições 13–14) continuam numéricos
                if (!/^[A-Z0-9]{12}\d{2}$/.test(cnpj)) return { cnpjInvalid: true }

                // Elimina CNPJs inválidos conhecidos
                if (/^(.)\1+$/.test(cnpj)) return { cnpjInvalid: true }

                // Converte cada caractere para seu valor numérico:
                // '0'–'9' → 0–9 | 'A'–'Z' → 10–35
                const charToValue = (ch: string): number => {
                    return ch.charCodeAt(0) - 48
                }

                // Cálculo do 1º dígito verificador (posições 1–12)
                const pesos1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
                let soma = 0
                for (let i = 0; i < 12; i++) {
                    soma += charToValue(cnpj[i]) * pesos1[i]
                }
                let resto = soma % 11
                const dv1 = resto < 2 ? 0 : 11 - resto

                if (dv1 !== parseInt(cnpj[12])) return { cnpjInvalid: true }

                // Cálculo do 2º dígito verificador (posições 1–13)
                const pesos2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
                soma = 0
                for (let i = 0; i < 13; i++) {
                    soma += charToValue(cnpj[i]) * pesos2[i]
                }
                resto = soma % 11
                const dv2 = resto < 2 ? 0 : 11 - resto

                if (dv2 !== parseInt(cnpj[13])) return { cnpjInvalid: true }

                return null;
            }

        }
        return null
	}

	static completeName(control: AbstractControl): ValidationErrors | null {
		const { value } = control
		if (value) {
			if (!/\w+\s+\w{2,}/.test(value)) {
				return { completeNameInvalid: true }
			}
		}
		return null
	}

	static validateCep(control: AbstractControl): ValidationErrors | null {
		let { value } = control
		if (value) {
			value = value.replace(/\D/g, '')
			if (value !== '') {
				if (!/^[0-9]{8}$/.test(value))
					return { validateCepInvalid: true }
			}
		}
		return null
	}

	static validateDate(control: AbstractControl): ValidationErrors | null {
		let { value } = control

		if (value && value.length >= 8) {
			const day = parseInt(value.substring(0, 2), 10)
			const month = parseInt(value.substring(2, 4), 10)
			const year = parseInt(value.substring(4, 8), 10)

			if (year < 1900 || year > 3000 || month === 0 || month > 12) {
				return { dateInvalid: true }
			}

			const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]

			if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
				monthLength[1] = 29
			}

			if (!(day > 0 && day <= monthLength[month - 1])) {
				return { dateInvalid: true }
			}
		}

		return null
	}

	static validatePhone(control: AbstractControl): ValidationErrors | null {
		let { value } = control
		if (value) {
			value = value.replace(/\D/g, '')
			if (value.length < 10) {
				return { phoneInvalid: true }
			}
			if (value.length === 10 && parseInt(value.substring(2, 3)) === 9) {
				return { phoneInvalid: true }
			}
			if (value.length === 11 && parseInt(value.substring(2, 3)) !== 9) {
				return { phoneInvalid: true }
			}
			const codigosDDD = [
				11, 12, 13, 14, 15, 16, 17, 18, 19, 21, 22, 24, 27, 28, 31, 32,
				33, 34, 35, 37, 38, 41, 42, 43, 44, 45, 46, 47, 48, 49, 51, 53, 54,
				55, 61, 62, 64, 63, 65, 66, 67, 68, 69, 71, 73, 74, 75, 77, 79,
				81, 82, 83, 84, 85, 86, 87, 88, 89, 91, 92, 93, 94, 95, 96, 97,
				98, 99,
			]
			if (!codigosDDD.includes(parseInt(value.substring(0, 2)))) {
				return { phoneInvalid: true }
			}
		}

		return null
	}

	static passwordCustom(control: AbstractControl): ValidationErrors | null {
		const { value } = control
		if (value) {
			if (
				!(
					/[a-z]+/.test(value) &&
					/[A-Z]+/.test(value) &&
					/\d+/.test(value) &&
					/[!@#$%^&*()]+/.test(value)
				)
			) {
				return { passwordCustomInvalid: true }
			}
		}
		return null
	}

	static atLeastOneLowerLetter(
		control: AbstractControl
	): ValidationErrors | null {
		const { value } = control
		if (value) {
			if (!/[a-z]+/.test(value)) {
				return { atLeastOneLowerLetterInvalid: true }
			}
		}
		return null
	}

	static atLeastOneUpperLetter(
		control: AbstractControl
	): ValidationErrors | null {
		const { value } = control
		if (value) {
			if (!/[A-Z]+/.test(value)) {
				return { atLeastOneUpperLetterInvalid: true }
			}
		}
		return null
	}

	static atLeastOneNumber(control: AbstractControl): ValidationErrors | null {
		const { value } = control
		if (value) {
			if (!/\d+/.test(value)) {
				return { atLeastOneNumberInvalid: true }
			}
		}
		return null
	}

	static atLeastOneSymbol(control: AbstractControl): ValidationErrors | null {
		const { value } = control
		if (value) {
			if (!/[!@#$%^&*()]+/.test(value)) {
				return { atLeastOneSymbolInvalid: true }
			}
		}
		return null
	}

	static checkEmails(control: AbstractControl): ValidationErrors | null {
		return !!control.parent &&
			!!control.parent.value &&
			// @ts-ignore
			control.value === control?.parent?.controls['email']?.value
			? null
			: { notSameEmail: false }
	}
	static checkPasswords(control: AbstractControl): ValidationErrors | null {
		return !!control.parent &&
			!!control.parent.value &&
			// @ts-ignore
			control.value === control?.parent?.controls['password']?.value
			? null
			: { notSamePassword: false }
	}
}
